enum LogoutReason {
    ExpiredToken,
    UserInitiated,
}

export default LogoutReason;
